import React, { useState } from 'react';
import Shape1 from '../../assets/images/banner-shape-one1.png';
import Shape2 from '../../assets/images/banner-shape2two.png';
import Shape3 from '../../assets/images/banner-shapethree3.png';
import Heroimg1 from '../../assets/images/hero-image-1.png'
import Heroimg2 from '../../assets/images/hero-image-2.png'
import Heroimg3 from '../../assets/images/hero-image-3.png'
import Heroimg4 from '../../assets/images/hero-image-4.png'
import Heroimg5 from '../../assets/images/hero-image-5.png'
import Playicon from "../../assets/images/play_icon.png"


function Banner() {

    const [ytShow, setytShow] = useState(false);

    return (
        <>
            <section className="banner_section homedark-banner">
                <div className="container">
                    <div className="row">
                        <span className="banner_shape1"> <img src={Shape1} alt="image" /> </span>
                        <span className="banner_shape2"> <img src={Shape2} alt="image" /> </span>
                        <span className="banner_shape3"> <img src={Shape3} alt="image" /> </span>

                        <div className="col-lg-8 col-md-12 mx-auto" data-aos="fade-right" data-aos-duration="1500">
                            <div className="banner_text">
                                <h1>Best way to manage your customers easily.</h1>
                                <p>Lorem Ipsum is simply dummy text of the printing and setting indus orem Ipsum has been the industrys standard dummy text ever.
                                </p>
                            </div>
                            <div className="yt_video" data-aos="fade-in" data-aos-duration="1500">
                                <div className="thumbnil">
                                    <a className="popup-youtube play-button" onClick={() => setytShow(true)} data-url="#" data-toggle="modal" data-target="#myModal" title="XJj2PbenIsU">
                                        <span className="play_btn">
                                            <img src={Playicon} alt="image" />
                                            <div className="waves-block">
                                                <div className="waves wave-1"></div>
                                                <div className="waves wave-2"></div>
                                                <div className="waves wave-3"></div>
                                            </div>
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-fluid" data-aos="fade-in" data-aos-duration="1500">
                    <div className="banner_images">
                        <div className="row d-flex justify-content-center">
                            <div className="col-md-2 col-lg-2 col-sm-4 col-xs-4 d-none d-lg-block">
                                <div className="banner_screen screen1">
                                    <img className="moving_position_animatin" src={Heroimg5} alt="image" />
                                </div>
                            </div>

                            <div className="col-md-4 col-lg-2 col-sm-4 col-xs-4">
                                <div className="banner_screen screen2">
                                    <img className="moving_animation" src={Heroimg4} alt="image" />
                                </div>
                            </div>

                            <div className="col-md-4 col-lg-3 col-sm-4 col-xs-4">
                                <div className="banner_screen screen3">
                                    <img className="moving_position_animatin" src={Heroimg1} alt="image" />
                                </div>
                            </div>

                            <div className="col-md-4 col-lg-2 col-sm-4 col-xs-4">
                                <div className="banner_screen screen4">
                                    <img className="moving_animation" src={Heroimg2} alt="image" />
                                </div>
                            </div>
                            <div className="col-md-2 col-lg-2 col-sm-4 col-xs-4 d-none d-lg-block">
                                <div className="banner_screen screen5">
                                    <img className="moving_position_animatin" src={Heroimg3} alt="image" />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {ytShow &&

                <>
                    <div className="modal fade youtube-video show" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-modal="true" style={{ paddingRight: "17px", display: "block" }}>
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <button id="close-video" type="button" className="button btn btn-default text-right" data-dismiss="modal">
                                    <i className="icofont-close-line-circled" onClick={() => setytShow(false)}></i>
                                </button>
                                <div className="modal-body">
                                    <div id="video-container" className="video-container">
                                        <iframe id="youtubevideo" src="https://www.youtube.com/embed/tgbNymZ7vqY?autoplay=1&amp;mute=1" width="640" height="360" frameborder="0" allowfullscreen=""></iframe>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="purple_backdrop">

                    </div>
                </>
            }

        </>
    )
}

export default Banner